import { Pipe, PipeTransform } from '@angular/core';
import { printToFrameSizeMap } from 'graphql/libs/look-book-client/src/print-frames/printFramesMap';
import { FramePickerService } from '@ui/look-book-front/print-frames/print-frames-front/frame-picker.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
    name: 'sizeAvailableInPrintFrames',
    standalone: false
})
export class SizeAvailableInPrintsPipe implements PipeTransform {
  constructor(private framePickerService: FramePickerService) {}

  transform(size: string): Observable<boolean> {
    return this.framePickerService
      .getOptionsForSize(size)
      .pipe(
        map(
          (options) => !!options.length
        )
      );
  }
}
